"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLastPlayableCharacterIndex = void 0;
const getMainMenuState_1 = require("./state/main-menu/getMainMenuState");
const getMaxCharacters_1 = require("./getMaxCharacters");
const getLastPlayableCharacterIndex = () => Math.min((0, getMainMenuState_1.getMainMenuState)().values.mainMenuCharacterIDs.length, (0, getMaxCharacters_1.getMaxCharacters)()) - 1;
exports.getLastPlayableCharacterIndex = getLastPlayableCharacterIndex;
